import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Box, Container, Typography, Button, Stack } from "@mui/material";

const Hero = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url(/assets/img/astronauta_playa_1_1980x1080.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        color: "white",
        textAlign: "center",
        px: 2,
      }}
    >
      {/* overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.5)",
        }}
      />
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: "light",
            fontSize: "clamp(1.8rem, 5vw, 3rem)",
            // min 1.8rem en móviles, escala con el viewport, máx 3rem en desktop
          }}
        >
          Un viaje sonoro de una hora por las vertientes más oscuras de la
          electrónica y el post-punk.
        </Typography>
        <Stack
          spacing={2}
          direction={{ xs: "column", sm: "row" }}
          justifyContent="center"
        >
          <Button
            variant="contained"
            size="large"
            href="https://www.mixcloud.com/live/merkurio/"
          >
            Escuchar en vivo - Domingos 21:00 (-3GMT)
          </Button>
          <Button
            variant="outlined"
            size="large"
            component={Link}
            to="/shows"
            sx={{
              color: "white", // color del texto
              borderColor: "white", // color del borde
              "&:hover": {
                borderColor: "white", // borde al pasar el mouse
                backgroundColor: "rgba(255,255,255,0.1)", // opcional, efecto hover
              },
            }}
          >
            <FormattedMessage id={"app.header.replay.label"} defaultMessage={"Episodios"} />
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default Hero;
